import {
  useEffect,
  useRef,
  useState
} from 'react'
import {
  useDispatch,
  useSelector
} from 'react-redux'
import {
  useNavigate,
  useSearchParams
} from 'react-router-dom'
import {
  Box,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerOverlay,
  IconButton,
  Image,
  Stack,
  Text,
  useDisclosure,
  useOutsideClick
} from '@chakra-ui/react'
import {
  ArrowIcon,
  SettingsIcon
} from 'assets/icons'
import { ImagesPng } from 'assets/images'
import { motion } from 'framer-motion'
import { withAuthentication } from 'HOC/IsUserAuth'
import L from 'leaflet'
import {
  authSelectors,
  chatCredentialsSelectors,
  getNotificationMessage,
  handleModalTitle,
  handleOpenModal,
  markersSelectors,
  setAuthPage,
  setBlogParent,
  getComments,
  setComments,
  setIsBlogFormOpen,
  setIsProfileSwitched,
  setLiveLocData,
  setOpenBlogForm,
  setSocMedDisplay,
  setSocMedDisplayStatus,
  setUserSectionPage,
  usersSelectors,
  setExecAutoArchive,
  setClosePane,
  setOnPostEditor,
  setCloseAllDrawers,
  setRepostThisPostData
} from 'store'
import {
  liveMarkerUpdate,
  staticMarkerUpdate
} from 'store/markers/axios'
import {
  MODAL_SECTION,
  MY_PROFILES,
  REJECTED,
  SETTINGS,
  SIGN_IN,
  SINGLE_PROFILE,
  VERIFY_PAGE,
  LOCATION_TYPE,
  PENDING
} from 'utils/constants'
import {
  getUrlParams,
  isAuth,
  isIOS,
  isNotMobile,
  showCoordParams
} from 'utils/helpers'
import { COLORS } from 'utils/styles'

/* eslint-disable import/no-cycle */
import { Messenger, UserSection } from 'components'
/* eslint-enable import/no-cycle */
import { SearchContainer } from 'components/SearchContainer'

import { CropPicture } from './CropPicture'
import { DiscardChanges } from './DiscardChanges'

const MotionDrawerContent = motion(DrawerContent)
const MotionStack = motion(Stack)

export const Header = () => {
  const {
    modalTitle,
    verificationEmailStandBy
  } = useSelector(authSelectors)
  const {
    user,
    activeProfile,
    blogParent,
    getCommentsStatus,
    isBlogFormOpen,
    isCloseModal,
    isSocialMediaSelectOpen,
    isProfileChanged,
    isProfileActive,
    isProfileIncomplete,
    isLocationOpen,
    isProfileDeleted,
    isPictureUploaded,
    closeResetProfileModal,
    cropFor,
    isProfileSwitched,
    postsTypeStatus,
    userSectionPage,
    onPostEditor,
    postPostsApiMsg,
    chosenBlogIndex,
    closePane,
    sharingToFriends,
    closeUserPanel,
    closeAllDrawers,
    markerOpenBeforeLogin,
    openBlogLink
  } = useSelector(usersSelectors)
  const {
    liveMarkerExp,
    selectedMarkerData,
    staticMarkerExp
  } = useSelector(markersSelectors)

  const { xmppLiveLocation } = useSelector(chatCredentialsSelectors)

  const { isOpen, onOpen, onClose } = useDisclosure()

  const btnRef = useRef()
  const drawerRef = useRef()
  const isFirstRender = useRef(true)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [isDiscard, setIsDiscard] = useState(false)
  const [isSetting, setIsSetting] = useState(false)
  const [isClickedOutside, setIsClickedOutside] = useState(true)
  const [isCloseable, setIsCloseable] = useState(true)
  const [closeTheModal, setCloseTheModal] = useState(false)
  const [closeCropModal, setCloseCropModal] = useState(true)
  const [liveReset, setLiveReset] = useState(false)
  const [staticReset, setStaticReset] = useState(false)
  const [updateReset, setUpdateReset] = useState(false)
  const [dynamicIsOpen, setDynamicIsOpen] = useState(false)
  let touchStart; let touchEnd
  const isBlogForMobile = () => isBlogFormOpen && !isNotMobile()
  const [blogFinishAnimation, setBlogFinishAnimation] = useState(false)
  const [runClosingAnimation, setRunClosingAnimation] = useState(false)
  const [localHidePanel, setLocalHidePanel] = useState(false)
  const [searchParams, setSearchParams] = useSearchParams()

  let id = sessionStorage.getItem('id')
  let intervalRef = useRef()
  const usePhoto = activeProfile && activeProfile.profile_picture
  if (localStorage.getItem('isLocDisabled') === null) {
    localStorage.setItem('isLocDisabled', false)
  }

  const goToHeaderOriginalPos = (parentData) => {
    const drawer = document.querySelector('#chakra-modal--body-user-drawer')
    const targetElement = document.querySelector('#blogStartItem' + chosenBlogIndex)

    if (
      drawer
      && parentData?.parent_type
    ) {
      drawer.scrollTo({
        top: 0,
        behavior: 'auto'
      })
    } else if (
      drawer
      && targetElement
    ) {
      requestAnimationFrame(() => {
        const containerTop = drawer.getBoundingClientRect().top
        const elementTop = targetElement.getBoundingClientRect().top
        const scrollDifference = Math.floor(elementTop) - containerTop

        drawer.scrollTop += scrollDifference
      })
    }
  }

  const handleCloseButton = () => {
    setIsClickedOutside(modalTitle !== VERIFY_PAGE.EditProfile)

    if (
      isAuth()
      && user
    ) {
      if (modalTitle === VERIFY_PAGE.MyProfiles) {
        onClose()
      } else if (
        modalTitle === VERIFY_PAGE.EditProfile
        && isProfileChanged === true
        && isSocialMediaSelectOpen === false
      ) {
        setIsDiscard(true)
      } else if (
        (
          modalTitle === VERIFY_PAGE.EditProfile
          && isProfileChanged === false
          && isSocialMediaSelectOpen === false
        )
        || modalTitle === VERIFY_PAGE.ProfileBlog
      ) {
        if (blogParent.length) {
          if (
            blogParent.length > 1
            && getCommentsStatus === PENDING
          ) {
            dispatch(getNotificationMessage({
              type: REJECTED,
              message: 'Please finish loading first before returning to previous blog post or comment',
              isEditProfile: true
            }))
          } else {
            const parentData = blogParent[blogParent.length - 1]

            goToHeaderOriginalPos(parentData)

            dispatch(setComments([]))
            if (parentData?.parent_type) {
              dispatch(getComments({
                type: parentData.parent_type,
                ...(parentData.parent_type === 'post' ? { post_id: parentData.post_id } : { comment_id: parentData.parent_comment_id })
              }))
            }
          }

          dispatch(setBlogParent(blogParent.slice(0, -1)))
        } else if (isProfileActive === true) {
          dispatch(handleModalTitle(VERIFY_PAGE.SingleProfile))
          dispatch(setUserSectionPage(SINGLE_PROFILE))
        } else {
          dispatch(setUserSectionPage(MY_PROFILES))
        }
      } else if (
        modalTitle === VERIFY_PAGE.EditProfile
        && isSocialMediaSelectOpen === true
      ) {
        dispatch(setSocMedDisplayStatus('none'))
        dispatch(setSocMedDisplay(false))
      } else {
        document.querySelector('#chakra-modal--body-user-drawer').scrollTop = 0
        dispatch(setUserSectionPage(MY_PROFILES))
      }
    } else if (modalTitle === VERIFY_PAGE.SignIn) {
      onClose()
    } else {
      dispatch(setAuthPage(SIGN_IN))
    }
  }

  const handleSettingButton = () => {
    setIsClickedOutside(false)

    if (modalTitle === VERIFY_PAGE.EditProfile && isProfileChanged === true) {
      setIsDiscard(true)
      setIsSetting(true)
    } else if (
      userSectionPage === SINGLE_PROFILE
      && modalTitle === VERIFY_PAGE.ProfileBlog
      && onPostEditor === 'post'
    ) {
      dispatch(setExecAutoArchive(true))
      dispatch(setOnPostEditor(''))
      setTimeout(() => dispatch(setUserSectionPage(SETTINGS)), 600)
    } else {
      dispatch(setUserSectionPage(SETTINGS))
    }
  }

  const blogHeader = () => {
    if (
      userSectionPage === SINGLE_PROFILE
      && modalTitle === VERIFY_PAGE.ProfileBlog
    ) {
      if (postPostsApiMsg !== '') {
        return postPostsApiMsg
      }

      if (onPostEditor === 'post') {
        return 'New Blog'
      }

      if (onPostEditor === 'put') {
        return 'Edit Blog'
      }

      if (postsTypeStatus === 'archived') {
        return 'Archived Blogs'
      }

      if (postsTypeStatus === 'scheduled') {
        return 'Scheduled Blogs'
      }

      return 'My Blogs'
    }

    return ''
  }

  useEffect(() => {
    if (modalTitle === VERIFY_PAGE.EditProfile) {
      setIsClickedOutside(true)
    }
  }, [modalTitle])

  useEffect(() => {
    if (closePane) {
      dispatch(setClosePane(false))
      handleCloseButton()
    }
  }, [closePane])

  useEffect(() => {
    if (
      getUrlParams('token', 'email')[0]
      && getUrlParams('token', 'email')[1]
    ) {
      onOpen()
    }
  }, [])

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false
      return
    }

    navigate('/')
    dispatch(handleOpenModal({ isOpen, section: MODAL_SECTION.LeftSection }))

    const customPopupOverlay = document.querySelector('#custom-popup-overlay')
    const customPopupOverlayEvent = document.querySelector('#custom-popup-overlay-event')
    if (customPopupOverlay && isAuth() && !markerOpenBeforeLogin) {
      customPopupOverlay.click()
    } else if (customPopupOverlayEvent && isAuth() && !markerOpenBeforeLogin) {
      customPopupOverlayEvent.click()
    }

    // The timeout is used to ensure other drawers/modals are closed before opening
    // Also used for the timing of fiter items' animation to left
    setRunClosingAnimation(!isOpen)
    setTimeout(() => {
      setLocalHidePanel(!isOpen)
      setTimeout(() => setDynamicIsOpen(isOpen), isOpen ? 0 : 50)

      setTimeout(() => {
        if (!isOpen && document.querySelectorAll('.chakra-modal__content').length === 0) {
          showCoordParams(setSearchParams)
        }

        if (!isOpen) {
          dispatch(setRepostThisPostData({}))
        }
      }, 200)
    }, isOpen ? 200 : 850)
  }, [isOpen])

  useEffect(() => {
    onClose()
  }, [isCloseModal])

  useEffect(() => {
    if (closeTheModal) {
      setCloseTheModal(false)
      onClose()
    }
  }, [closeTheModal])

  const getRandomDecimalWithPrecision = (min, max, precision) => {
    const factor = 10 ** precision
    min *= factor
    max *= factor
    return (Math.floor(Math.random() * (max - min + 1)) + min) / factor
  }

  // User Live Loc Update
  useEffect(() => {
    const activeID = activeProfile?.id
    const activeLocType = activeProfile?.location_type
    const activeCoordinates = activeProfile?.coordinates
    let addRadiusLat = 0
    let addRadiusLng = 0

    if (
      (
        activeID
        && (
          activeLocType?.[LOCATION_TYPE.LiveLocation] === 0
          || activeLocType?.[LOCATION_TYPE.LiveApproximate] === 1
        )
      )
      && Number.isNaN(xmppLiveLocation?.lat) === false
    ) {
      if (activeLocType?.[LOCATION_TYPE.LiveApproximate] === 1) {
        addRadiusLat = getRandomDecimalWithPrecision(-0.001, 0.001, 4)
        addRadiusLng = getRandomDecimalWithPrecision(-0.001, 0.001, 4)
      }

      let newCoords = {
        lat: Number((parseFloat(xmppLiveLocation?.lat) + addRadiusLat).toFixed(6)),
        lng: Number((parseFloat(xmppLiveLocation?.lng) + addRadiusLng).toFixed(6))
      }

      setTimeout(() => {
        if (
          activeCoordinates?.lat !== xmppLiveLocation?.lat
          && activeCoordinates?.lng !== xmppLiveLocation?.lng
          && sessionStorage.getItem('id') === null
        ) {
          const distance = (L.latLng(activeCoordinates)).distanceTo(L.latLng(xmppLiveLocation))

          // check whether the distance between the old and new coords is >= 10 meters
          if (distance >= 10) {
            dispatch(setLiveLocData({ id: activeID, coordinates: newCoords }))
          }
        }
        setUpdateReset(!updateReset)
      }, 60000)
    } else {
      setTimeout(() => setUpdateReset(!updateReset), 5000)
    }
  }, [updateReset])

  // Live Update Interval
  useEffect(() => {
    let currentDate = new Date().toLocaleString('en-US', { timeZone: 'UTC', hour12: false })
    if (liveMarkerExp) {
      let liveMarkerDate = new Date(liveMarkerExp).toLocaleString('en-US', { hour12: false })
      // let duration = new Date(liveMarkerDate).getTime() - new Date(currentDate).getTime()
      let northeast = JSON.parse(localStorage.getItem('northeast'))
      let southwest = JSON.parse(localStorage.getItem('southwest'))

      setTimeout(() => {
        // console.log(currentDate >= liveMarkerDate)
        // console.log(duration / 1000 + ' seconds')
        if (
          currentDate >= liveMarkerDate
          && sessionStorage.getItem('id') === null
          && localStorage.getItem('isNotifOpen') === 'false'
        ) {
          dispatch(liveMarkerUpdate({
            isAuth: isAuth(),
            northeast,
            southwest
          }))

          // Testing
          // console.log('Live is working')
          // console.log(currentDate + '')
          // console.log('Live Marker Expiration: ' + liveMarkerDate)
        }
        setLiveReset(!liveReset)
      }, 60000)
    } else {
      setTimeout(() => setLiveReset(!liveReset), 5000)
    }
  }, [liveReset])

  // Static Update Interval
  useEffect(() => {
    let currentDate = new Date().toLocaleString('en-US', { timeZone: 'UTC', hour12: false })
    if (staticMarkerExp) {
      let staticMarkerDate = new Date(staticMarkerExp).toLocaleString('en-US', { hour12: false })
      // let duration = new Date(staticMarkerDate).getTime() - new Date(currentDate).getTime()
      let northeast = JSON.parse(localStorage.getItem('northeast'))
      let southwest = JSON.parse(localStorage.getItem('southwest'))

      setTimeout(() => {
        // console.log(currentDate >= staticMarkerDate)
        // console.log(duration / 1000 + ' seconds')
        if (
          currentDate >= staticMarkerDate
          && sessionStorage.getItem('id') === null
          && localStorage.getItem('isNotifOpen') === 'false'
        ) {
          dispatch(staticMarkerUpdate({
            isAuth: isAuth(),
            northeast,
            southwest
          }))
          // Testing
          // console.log('Static is working')
          // console.log(currentDate + '')
          // console.log('Static Marker Expiration: ' + staticMarkerDate)
        }
        setStaticReset(!staticReset)
      }, 60000)
    } else {
      setTimeout(() => setStaticReset(!staticReset), 5000)
    }
  }, [staticReset])

  useEffect(() => {
    if (isProfileSwitched === true) {
      clearInterval(intervalRef.current)
      dispatch(setIsProfileSwitched(false))
    }
  }, [isProfileSwitched])

  const closingCondition = () => {
    if (closeCropModal && closeResetProfileModal) {
      if (modalTitle === VERIFY_PAGE.EditProfile && isSocialMediaSelectOpen === false) {
        if (isProfileChanged === true && isLocationOpen === false) {
          if (!isIOS()) {
            setIsCloseable(false)
          }
          setIsDiscard(true)
        } else if (
          isLocationOpen === true
          && (isProfileChanged === true || isProfileChanged === false)
        ) {
          if (!isIOS()) {
            setIsCloseable(false)
          }
          setIsDiscard(false)
        } else {
          onClose()
        }
      } else if (modalTitle === VERIFY_PAGE.EditProfile && isSocialMediaSelectOpen === true) {
        if (isProfileChanged === true) {
          setIsCloseable(false)
          dispatch(setSocMedDisplay(false))
          dispatch(setSocMedDisplayStatus('none'))
        } else {
          setIsDiscard(false)
          dispatch(setSocMedDisplay(false))
          dispatch(setSocMedDisplayStatus('none'))
        }
      } else if (modalTitle === VERIFY_PAGE.Settings) {
        if (isProfileDeleted === true) {
          setIsCloseable(false)
        } else {
          setIsCloseable(true)
          onClose()
        }
      } else {
        if (
          userSectionPage === SINGLE_PROFILE
          && modalTitle === VERIFY_PAGE.ProfileBlog
          && onPostEditor === 'post'
        ) {
          dispatch(setExecAutoArchive(true))
          dispatch(setOnPostEditor(''))
        }

        setIsDiscard(false)
        dispatch(setSocMedDisplay(false))
        dispatch(setSocMedDisplayStatus('none'))
        onClose()
      }
    }
  }

  // For Clicking outside the header
  useOutsideClick({
    ref: drawerRef,
    handler: () => {
      if (!sharingToFriends && !openBlogLink) {
        closingCondition()
      }
    }
  })

  useEffect(() => {
    if (closeUserPanel) {
      closingCondition()
    }
  }, [closeUserPanel])

  useEffect(() => {
    setTimeout(() => setBlogFinishAnimation(isBlogForMobile()), 350)
  }, [isBlogFormOpen])

  useEffect(() => {
    if (closeAllDrawers) {
      onClose()
    }
  }, [closeAllDrawers])

  useEffect(() => {
    if (verificationEmailStandBy) {
      onClose()
    }
  }, [verificationEmailStandBy])

  return (
    <>
      <MotionStack
        background={COLORS.gold}
        className="header"
      >
        <MotionStack
          initial={{
            y: 0
          }}
          animate={{
            y: isBlogForMobile() ? -50 : 0
          }}
          transition={{
            type: 'tween',
            duration: 0.8
          }}
          display="flex"
          justifyContent="center"
          paddingBlock="9px"
          spacing={{
            base: '10px',
            sm: '10px',
            md: '10px',
            lg: '10px'
          }}
          direction="row"
          alignItems="center"
          background={COLORS.gold}
        >
          {isAuth() ? (
            <Image
              boxSize="32px"
              cursor="pointer"
              objectFit="cover"
              src={usePhoto || ImagesPng.UserImage}
              alt="Logo"
              borderRadius="full"
              onClick={() => {
                sessionStorage.removeItem('openProfileAfterAnimation')
                sessionStorage.removeItem('openEventAfterAnimation')

                if (
                  !searchParams.get('id')
                  && !searchParams.get('post-id')
                  && !searchParams.get('eventid')
                  && !selectedMarkerData
                ) {
                  document.querySelector('div.leaflet-container').click()
                  dispatch(setUserSectionPage(MY_PROFILES))
                  dispatch(setIsBlogFormOpen(false))
                  dispatch(setOpenBlogForm(false))
                  onOpen()
                }
              }}
              onLoad={() => {
                if (id !== null && !isAuth()) {
                  onOpen()
                }
              }}
              ref={btnRef}
              className="profile-icon"
            />
          ) : (
            <Image
              as={motion.img}
              animate={{
                scale: [1, 1.1, 1],
                opacity: [1, 0.8, 1],
                transition: {
                  repeat: Infinity,
                  duration: 1
                }
              }}
              boxSize="32px"
              cursor="pointer"
              objectFit="cover"
              src={usePhoto || ImagesPng.UserImage}
              alt="Logo"
              borderRadius="full"
              onClick={() => {
                if (isAuth()) {
                  document.querySelector('div.leaflet-container').click()
                }

                onOpen()
              }}
              ref={btnRef}
              className="profile-icon"
            />
          )}

          <SearchContainer />

          <Messenger />
        </MotionStack>
      </MotionStack>

      <Drawer
        id="user-drawer"
        isOpen={dynamicIsOpen}
        placement="left"
        onClose={onClose}
        finalFocusRef={btnRef}
        size="sm"
        blockScrollOnMount={false}
        closeOnOverlayClick={isCloseable}
        closeOnEsc={false}
        onEsc={() => handleCloseButton()}
      >
        <DrawerOverlay
          zIndex="1300"
          background="transparent"
          onClick={() => {
            dispatch(setCloseAllDrawers(true))
            setTimeout(() => dispatch(setCloseAllDrawers(false)), 850)
          }}
        />
        <MotionDrawerContent
          initial={{
            x: runClosingAnimation ? 0 : -500,
            marginBlock: isBlogForMobile() ? '60px' : '60px',
            marginInline: isBlogForMobile() ? '10px' : '10px',
            width: isBlogForMobile() ? '95%' : '95%',
            borderRadius: isBlogForMobile() ? '10px' : '10px'
          }}
          animate={{
            x: runClosingAnimation ? -500 : 0,
            marginBlock: isBlogForMobile() ? '0px' : '60px',
            marginInline: isBlogForMobile() ? '0px' : '10px',
            width: isBlogForMobile() ? '100%' : '95%',
            borderRadius: isBlogForMobile() ? '0px' : '10px'
          }}
          transition={{
            type: isBlogForMobile() || blogFinishAnimation || runClosingAnimation ? 'tween' : 'spring',
            duration: isBlogForMobile() || blogFinishAnimation ? 1 : 0.8
          }}
          opacity={localHidePanel ? 0 : 1}
          overflow="hidden"
          maxWidth="450px"
          ref={drawerRef}
        >
          <Stack
            alignItems="center"
            justifyContent="space-between"
            direction="row"
            p="0px 0"
            background={
              isNotMobile()
                ? COLORS.goldGradientLeftToRight
                : COLORS.goldGradientRightToLeft
            }
            zIndex={5}
            height="48px"
            overflow="hidden"
            onTouchStart={(e) => {
              touchStart = e?.targetTouches[0].clientX
            }}
            onTouchMove={(e) => {
              touchEnd = e?.targetTouches[0].clientX
            }}
            onTouchEnd={() => {
              if (touchStart - touchEnd > 45) {
                closingCondition()
              }
            }}
          >
            <IconButton
              name="profile-pane-back-btn"
              _hover={{ background: COLORS.gold_hover }}
              background="unset"
              style={{
                marginLeft: '5px'
              }}
              icon={<ArrowIcon />}
              onClick={() => {
                if (isBlogFormOpen) {
                  dispatch(setOpenBlogForm(false))
                } else if (
                  userSectionPage === SINGLE_PROFILE
                  && modalTitle === VERIFY_PAGE.ProfileBlog
                  && onPostEditor === 'post'
                ) {
                  dispatch(setExecAutoArchive(true))
                  dispatch(setOnPostEditor(''))
                } else {
                  handleCloseButton()
                }
              }}
              outline="none"
              boxShadow="none"
              css={{
                ':focus': {
                  outline: 'none',
                  boxShadow: 'none'
                }
              }}
            />

            {
              modalTitle === VERIFY_PAGE.EditProfile && isSocialMediaSelectOpen
                ? (
                  <>
                    <Text
                      whiteSpace="nowrap"
                      fontSize="20px"
                      sx={{
                        marginLeft: '105px !important',
                        '@media (max-width: 480px)': {
                          marginLeft: '65px !important'
                        }
                      }}
                      fontWeight={600}
                    >
                      {
                        modalTitle === VERIFY_PAGE.EditProfile && isSocialMediaSelectOpen
                          ? 'Choose Platform' : ''
                      }
                    </Text>
                    <Box width="95%" />
                  </>
                ) : ''
            }

            {
              userSectionPage === SINGLE_PROFILE
              && modalTitle === VERIFY_PAGE.ProfileBlog
                ? (
                  <Text
                    whiteSpace="nowrap"
                    fontSize="18px"
                    fontWeight={500}
                    backgroundColor={postPostsApiMsg === '' ? '' : '#FBFCF8'}
                    padding={postPostsApiMsg === '' ? '' : '0 10px'}
                    borderRadius={postPostsApiMsg === '' ? '' : '5px'}
                  >
                    { blogHeader() }
                  </Text>
                ) : ''
            }

            {
              user
              && !isSocialMediaSelectOpen
                ? (
                  <IconButton
                    _hover={{ background: COLORS.gold_hover }}
                    background="unset"
                    icon={<SettingsIcon />}
                    onClick={handleSettingButton}
                    outline="none"
                    boxShadow="none"
                    opacity={isBlogForMobile() || isBlogFormOpen ? 0 : 1}
                    pointerEvents={isBlogForMobile() || isBlogFormOpen ? 'none' : 'auto'}
                    css={{
                      marginRight: '5px',
                      ':focus': {
                        outline: 'none',
                        boxShadow: 'none'
                      }
                    }}
                  />
                ) : null
            }
          </Stack>

          <DrawerBody
            sx={{
              overflowX: 'hidden',
              '::MsOverflowStyle': 'none',
              scrollbarWidth: 'none',
              '::-webkit-scrollbar': {
                display: 'none'
              },
              overflowY: isBlogFormOpen ? 'hidden !important' : ''
            }}
            margin="0px"
            padding="0px"
          >
            {withAuthentication(UserSection)}
          </DrawerBody>
          <DiscardChanges
            isDiscard={isDiscard}
            setIsDiscard={setIsDiscard}
            setIsCloseable={setIsCloseable}
            isProfileActive={isProfileActive}
            isProfileIncomplete={isProfileIncomplete}
            isSetting={isSetting}
            setIsSetting={setIsSetting}
            isClickedOutside={isClickedOutside}
            setIsClickedOutside={setIsClickedOutside}
            setCloseTheModal={setCloseTheModal}
            closeCropModal={closeCropModal}
          />
          <CropPicture
            isPictureUploaded={isPictureUploaded}
            setCloseCropModal={setCloseCropModal}
            cropFor={cropFor}
          />
        </MotionDrawerContent>
      </Drawer>
    </>
  )
}
